/*
 * KM - prices are found and rewritten using the shop's money format (set on window in theme.liquid),
 * e.g. "${{amount}}". The placeholder name decides the [decimals, thousands, decimal] separators.
 * Recharge formats its prices with the same format (its `currency_format` setting).
 * Don't think this is currently needed, as we only display prices in USD. Leaving just in case.
 */
// const [MONEY_PREFIX, MONEY_PLACEHOLDER, MONEY_SUFFIX] = window.moneyFormat.replace(/<[^>]*>/g, '').split(/\{\{\s*(\w+)\s*\}\}/);
// const [MONEY_DECIMALS, MONEY_THOUSANDS, MONEY_DECIMAL] = {
//   amount_no_decimals: [0, ',', '.'],                     // 1,135
//   amount_with_comma_separator: [2, '.', ','],            // 1.134,65
//   amount_no_decimals_with_comma_separator: [0, '.', ','],// 1.135
//   amount_with_apostrophe_separator: [2, "'", '.'],       // 1'134.65
//   amount_no_decimals_with_space_separator: [0, ' ', '.'],// 1 135
//   amount_with_space_separator: [2, ' ', ','],            // 1 134,65
//   amount_with_period_and_space_separator: [2, ' ', '.']  // 1 134.65
// }[MONEY_PLACEHOLDER] || [2, ',', '.'];                    // {{amount}}: 1,134.65
// const escapeForRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
// const MONEY_PATTERN = new RegExp(
//   `${escapeForRegExp(MONEY_PREFIX)}(\\d+(?:${escapeForRegExp(MONEY_THOUSANDS)}\\d{3})*` +
//   `${MONEY_DECIMALS ? `${escapeForRegExp(MONEY_DECIMAL)}\\d{${MONEY_DECIMALS}}` : ''})${escapeForRegExp(MONEY_SUFFIX)}`,
//   'g'
// );

/* KM - prices are always USD ("$1,134.65"), both from the theme's `money` filter and from Recharge */
const USD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

/* KM - multiplies every price in a piece of text, e.g. ("Save 10% - $26.99", 3) -> "Save 10% - $80.97" */
function multiplyPrices(text, quantity) {
    // Don't think this is needed - only needed if prices display in multiple currencies
    //   return text.replace(MONEY_PATTERN, (price, amount) => {
    //     const digits = String(amount.replace(/\D/g, '') * quantity).padStart(MONEY_DECIMALS + 1, '0');
    //     const whole = digits.slice(0, digits.length - MONEY_DECIMALS).replace(/\B(?=(\d{3})+$)/g, MONEY_THOUSANDS);
    //     return price.replace(amount, MONEY_DECIMALS ? `${whole}${MONEY_DECIMAL}${digits.slice(-MONEY_DECIMALS)}` : whole);
    //   });
  return text.replace(/\$[\d,]+\.\d{2}/g, (price) => USD.format(price.replace(/[$,]/g, '') * quantity));
}

/*
 * KM - the unit price is kept on each price span so totals are always computed from it. It survives
 * global.js copying the price block's HTML into the add to cart button, and is dropped when a
 * variant change renders fresh price HTML.
 */
function applyQuantityToPrices({ sectionId, quantity }) {
  const priceBlocks = `[id^="price-${sectionId}"], [id^="product-form-${sectionId}"] .price-inside-button`;
  document.querySelectorAll(`:is(${priceBlocks}) :is(.sale-price, .regular-price)`).forEach((el) => {
    el.dataset.unitPrice ??= el.innerHTML;
    el.innerHTML = multiplyPrices(el.dataset.unitPrice, quantity);
  });

  applyQuantityToRechargeWidget(sectionId, quantity);
}

const RECHARGE_PRICES = ['rc-purchase-option__price', 'rc-purchase-option__original-price', 'rc-purchase-option__discounted-price']
  .map((part) => `[part~="${part}"]`).join(',');
const rechargeUnitText = new WeakMap(); // text node -> { unit, written }

/*
 * KM - the Recharge widget renders with Lit inside an open shadow root, so only text node data is
 * rewritten (never elements) to keep Lit's markers intact. A node whose text no longer matches what
 * we wrote has been re-rendered by Recharge, so its new text is the unit price.
 */
function scaleRechargeWidget(widget) {
  const root = widget.shadowRoot;
  if (root.querySelector('recharge-quantity-upsell')) return; // Recharge controls quantity there

  /*
   * KM - for each widget price element (one-time, strikethrough, subscription), visit every text node
   * inside it. One element can hold several, e.g. the discounted price has a screen-reader label
   * (", Discounted price:") and the price itself, each in its own node; nodes without a price are left
   * as-is by multiplyPrices. Each node's unit text is worked out (remembered, or freshly rendered by
   * Recharge) and the node is rewritten with the total, only touching the DOM if the text changed.
   */
  root.querySelectorAll(RECHARGE_PRICES).forEach((el) => {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      const state = rechargeUnitText.get(node);
      const unit = state && node.data === state.written ? state.unit : node.data;
      const written = multiplyPrices(unit, Number(widget.dataset.quantity));
      rechargeUnitText.set(node, { unit, written });
      if (node.data !== written) node.data = written;
    }
  });
}

function applyQuantityToRechargeWidget(sectionId, quantity) {
  const widget = document.querySelector(`section[data-section="${sectionId}"] recharge-subscription-widget`);
  if (!widget) return;

  const isObserved = 'quantity' in widget.dataset;
  widget.dataset.quantity = quantity;

  // The widget isn't upgraded yet if the quantity changes before Recharge's script loads
  customElements.whenDefined('recharge-subscription-widget').then(() => {
    if (!isObserved) {
      new MutationObserver(() => scaleRechargeWidget(widget))
        .observe(widget.shadowRoot, { subtree: true, childList: true, characterData: true });
    }
    scaleRechargeWidget(widget);
  });
}

/* KM - dispatched by QuantityInput in global.js; sectionId is null for cart inputs */
document.addEventListener('quantity:change', (evt) => {
  if (evt.detail.sectionId) applyQuantityToPrices(evt.detail);
});

/* KM - a variant change renders fresh single-unit prices, so re-announce the current quantity */
subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
  document.getElementById(`Quantity-${data.sectionId}`)?.closest('quantity-input')?.dispatchQuantityChange();
});
